export default class CardHover {

    constructor(el) {

        this.el = el;

        if(!this.el) {
            return;
        }

        this.breakpoint = window.matchMedia('(max-width:1200px)');
        this.title = this.el.querySelector('[data-card-title]');

        if(!this.breakpoint.matches) {

            document.addEventListener('mousemove', (e) => {
                this.clientY = e.clientY;
            });

            this.el.addEventListener('mouseover', (e) => {
                this.showText();
            });

            this.el.addEventListener('mouseout', (e) => {
                this.hideText();
            });

            requestAnimationFrame((timestamp) => this.render(timestamp));

        }

    }

    showText() {
        this.title.style.opacity = 1;
    }

    hideText() {
        this.title.style.opacity = 0;
    }

    render(timestamp) {

		this.title.style.transform = `translateY(${this.clientY - this.el.getBoundingClientRect().top}px)`;
		requestAnimationFrame((timestamp) => this.render(timestamp));
	}
}
